import { render, staticRenderFns } from "./Paylike.vue?vue&type=template&id=8d1d082a&"
import script from "./Paylike.vue?vue&type=script&lang=js&"
export * from "./Paylike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports